import PropTypes from "prop-types";
import { FormattedMessage, useIntl } from "react-intl";
import thumbsDownIcon from "../../../assets/thumbs-down.svg";
import Card from "../Card/Card";
import styles from "./Error.module.scss";
import Button, { LIGHT } from "../Button/Button";

export const parseError = (error) => {
  const errArray = error.split(":");
  if (errArray.length > 0 && errArray[0] === "Controller") {
    return errArray[errArray.length - 1];
  }
  return error;
};

const Error = ({ message }) => {
  const { formatMessage } = useIntl();

  const onRefresh = () => {
    window.location.reload();
  };

  return (
    <Card className="d-flex flex-column align-items-center justify-content-center p-5">
      <div className="d-flex">
        <img
          className={`${styles.icon} mx-3 mt-1`}
          src={thumbsDownIcon}
          alt={formatMessage({ id: "error.title" })}
        />
        <div className="flex-grow-1">
          <div className="font-size-24 font-weight-500">
            <FormattedMessage id="error.title" />
          </div>
          <div className="font-size-14">
            <FormattedMessage id={parseError(message) || "error.subtitle"} />
          </div>
          <Button className="mt-3" variant={LIGHT} onClick={onRefresh}>
            <FormattedMessage id="error.refresh" />
          </Button>
        </div>
      </div>
    </Card>
  );
};

Error.propTypes = {
  message: PropTypes.string,
};

Error.defaultProps = {
  message: "",
};

export default Error;
